import React, { createContext, useContext, useState, useEffect } from 'react';
import LoadingOverlayManager from './LoadingOverlayManager';

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    LoadingOverlayManager.register(setVisible);
  }, []);

  const showLoading = () => setVisible(true);
  const hideLoading = () => setVisible(false);

  return (
    <LoadingContext.Provider value={{ visible, showLoading, hideLoading }}>
      {children}
      {visible && <LoadingOverlay />}
    </LoadingContext.Provider>
  );
};

const LoadingOverlay = () => (
  <div style={{
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  }}>
    <div style={{
      width: 50,
      height: 50,
      border: '6px solid #f3f3f3',
      borderTop: '6px solid #3498db',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);
